"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChimeMetricsProcessor = void 0;
var _networkHealthUtil = require("./systemHealth/networkHealthUtil");
var _logger = require("@studio/logger");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var defaultMeetingQuality = {
  audio: {
    available: false,
    score: {
      min: 0,
      avg: 0,
      max: 0
    },
    dataSets: []
  },
  downVideo: {
    onStage: {
      available: false,
      videoScore: {
        min: 0,
        avg: 0,
        max: 0
      },
      fpsScore: {
        min: 0,
        avg: 0,
        max: 0
      },
      resolutionScore: {
        min: 0,
        avg: 0,
        max: 0
      },
      receivingMosScore: {
        min: 0,
        avg: 0,
        max: 0
      },
      senderMosScore: {
        min: 0,
        avg: 0,
        max: 0
      },
      dataSets: []
    },
    offStage: {
      available: false,
      videoScore: {
        min: 0,
        avg: 0,
        max: 0
      },
      fpsScore: {
        min: 0,
        avg: 0,
        max: 0
      },
      resolutionScore: {
        min: 0,
        avg: 0,
        max: 0
      },
      receivingMosScore: {
        min: 0,
        avg: 0,
        max: 0
      },
      senderMosScore: {
        min: 0,
        avg: 0,
        max: 0
      },
      dataSets: []
    }
  },
  upVideo: {
    available: false,
    onStage: false,
    videoScore: {
      min: 0,
      avg: 0,
      max: 0
    },
    fpsScore: {
      min: 0,
      avg: 0,
      max: 0
    },
    resolutionScore: {
      min: 0,
      avg: 0,
      max: 0
    },
    receivingMosScore: {
      min: 0,
      avg: 0,
      max: 0
    },
    senderMosScore: {
      min: 0,
      avg: 0,
      max: 0
    },
    dataSets: []
  }
};
var ChimeMetricsProcessor = exports.ChimeMetricsProcessor = /*#__PURE__*/function () {
  function ChimeMetricsProcessor() {
    _classCallCheck(this, ChimeMetricsProcessor);
    _defineProperty(this, "audioQuality", []);
    _defineProperty(this, "videoQuality", {});
    _defineProperty(this, "remoteAttendeeNetworkHealth", {});
    _defineProperty(this, "meetingSession", null);
    _defineProperty(this, "metricReport", null);
    _defineProperty(this, "videoMetricReport", null);
    _defineProperty(this, "onstageAttendees", {});
    _defineProperty(this, "onstageAttendeeSyncJobStarted", false);
    _defineProperty(this, "meetingQuality", JSON.parse(JSON.stringify(defaultMeetingQuality)));
    _defineProperty(this, "downVideoOnStageCount", 0);
    _defineProperty(this, "downVideoOffStageCount", 0);
    _defineProperty(this, "upVideoCount", 0);
    if (ChimeMetricsProcessor.instance) {
      return ChimeMetricsProcessor.instance;
    }
    ChimeMetricsProcessor.instance = this;
    return this;
  }
  _createClass(ChimeMetricsProcessor, [{
    key: "updateRemoteAttendeeNetworkHealth",
    value:
    /**
     * Keep track of network health of remote attendees
     * This is the same data sent by remote attendees as part of network health indicators and monitoring stats
     * Updated everytime we receive network health stats for a remote attendee
     */
    function updateRemoteAttendeeNetworkHealth(remoteAttendeeId, networkHealthData) {
      this.remoteAttendeeNetworkHealth[remoteAttendeeId] = networkHealthData;
    }
  }, {
    key: "updateOnstageAttendees",
    value: function updateOnstageAttendees(onstageAttendees) {
      this.onstageAttendees = onstageAttendees;
    }
  }, {
    key: "updateOnstageAttendeesForHost",
    value: function updateOnstageAttendeesForHost(onstageAttendees) {
      this.updateOnstageAttendees(onstageAttendees);
      this.sendOnstageAttendeesUpdate();
      if (!this.onstageAttendeeSyncJobStarted) {
        this.startOnstageAttendeeSyncJob();
        this.onstageAttendeeSyncJobStarted = true;
      }
    }
  }, {
    key: "sendOnstageAttendeesUpdate",
    value: function sendOnstageAttendeesUpdate() {
      if (this.meetingSession && this.meetingSession.audioVideo) {
        this.meetingSession.audioVideo.realtimeSendDataMessage('AttendeeUpdate', this.onstageAttendees, 5000);
      }
    }
  }, {
    key: "startOnstageAttendeeSyncJob",
    value: function startOnstageAttendeeSyncJob() {
      var _this = this;
      setInterval(function () {
        return _this.sendOnstageAttendeesUpdate();
      }, 5000);
    }

    /**
     * Process metrics received via MetricsDidReceive
     */
  }, {
    key: "process",
    value: function process(clientMetricReport, currentAttendeeId, meetingSession) {
      this.meetingSession = meetingSession;
      var metricReport = clientMetricReport.getObservableMetrics();
      var videoMetricReport = clientMetricReport.getObservableVideoMetrics();
      this.metricReport = metricReport;
      this.videoMetricReport = videoMetricReport;
      this.audioQuality.push(this.getAudioQualityData(metricReport));
      for (var attendeeId in videoMetricReport) {
        if (attendeeId === currentAttendeeId) {
          this.getUpstreamVideoQualityData(attendeeId, Object.values(videoMetricReport[attendeeId])[0]);
        }
        if (attendeeId !== currentAttendeeId) {
          if (!this.videoQuality.hasOwnProperty(attendeeId)) {
            this.videoQuality[attendeeId] = [];
          }
          var videoMetricsData = Object.values(videoMetricReport[attendeeId])[0];
          this.videoQuality[attendeeId].push(this.getVideoQualityData(attendeeId, videoMetricsData));
        }
      }
      if (this.audioQuality.length === 10) {
        this.meetingQuality.audio.score.avg = Math.round(this.meetingQuality.audio.score.avg / this.audioQuality.length * 100) / 100;
        this.calculateVideoScoreAvgs(this.meetingQuality.downVideo.onStage, this.downVideoOnStageCount);
        this.calculateVideoScoreAvgs(this.meetingQuality.downVideo.offStage, this.downVideoOffStageCount);
        this.calculateVideoScoreAvgs(this.meetingQuality.upVideo, this.upVideoCount);
        var qualityLog = {
          audio: this.audioQuality,
          video: this.videoQuality,
          meetingQuality: this.meetingQuality
        };
        (0, _logger.sendToDatadog)('chime-quality-log', qualityLog, "Chime quality logs for ".concat(currentAttendeeId));
        this.audioQuality = [];
        this.videoQuality = {};
        this.meetingQuality = JSON.parse(JSON.stringify(defaultMeetingQuality));
        this.downVideoOnStageCount = 0;
        this.downVideoOffStageCount = 0;
        this.upVideoCount = 0;
      }
    }
  }, {
    key: "getAudioQualityData",
    value: function getAudioQualityData(metricReport) {
      var audioQualityData = [];
      var audioPacketLossPercent = metricReport['audioPacketsReceivedFractionLoss'];
      var audioJitter = metricReport['audioDownstreamJitterMs'];
      var audioRTT = metricReport['currentRoundTripTimeMs'];
      var audioMOS = this.computeMOS(audioPacketLossPercent, audioJitter, audioRTT);

      /**
       * Receiver-side (down-link) audio MOS
       * Represents quality of (mixed) audio received
       */
      audioQualityData.push("rmos:".concat(audioMOS));
      var audioScores = [];
      var audioMOSBasedScore = this.getMOSBasedQualityScore(audioMOS);
      audioScores.push(audioMOSBasedScore);
      var onstageAttendees = this.getOnstageAttendeeIds();
      var _iterator = _createForOfIteratorHelper(onstageAttendees),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var onstageAttendeeId = _step.value;
          if (this.isAttendeeSpeaking(onstageAttendeeId) && this.remoteAttendeeNetworkHealth.hasOwnProperty(onstageAttendeeId)) {
            var remoteAttendeeAudioMOS = this.remoteAttendeeNetworkHealth[onstageAttendeeId]['audioMOS'];
            audioQualityData.push("smos:".concat(remoteAttendeeAudioMOS));
            audioScores.push(this.getMOSBasedQualityScore(remoteAttendeeAudioMOS));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.meetingQuality.audio.available = true;
      var audioQualityScore = Math.min.apply(Math, audioScores);
      if (this.meetingQuality.audio.score.min === 0 || this.meetingQuality.audio.score.min > audioQualityScore) {
        this.meetingQuality.audio.score.min = audioQualityScore;
      }
      if (this.meetingQuality.audio.score.max === 0 || this.meetingQuality.audio.score.max < audioQualityScore) {
        this.meetingQuality.audio.score.max = audioQualityScore;
      }
      this.meetingQuality.audio.score.avg += audioQualityScore;
      audioQualityData.push("fs: ".concat(audioQualityScore));
      var dataSet = audioQualityData.join('::');
      this.meetingQuality.audio.dataSets.push(dataSet);
      return dataSet;
    }
  }, {
    key: "getVideoQualityData",
    value: function getVideoQualityData(attendeeId, videoMetricsData) {
      var videoQualityData = [];
      var isOnStage = this.isAttendeeOnStage(attendeeId) ? 1 : 0;
      var meetingQualityType;
      if (isOnStage === 1) {
        this.downVideoOnStageCount += 1;
        meetingQualityType = this.meetingQuality.downVideo.onStage;
      } else {
        this.downVideoOffStageCount += 1;
        meetingQualityType = this.meetingQuality.downVideo.offStage;
      }
      meetingQualityType.available = true;
      videoQualityData.push("n:".concat((0, _networkHealthUtil.getNumMeetingParticipants)(this.meetingSession)));
      videoQualityData.push("os:".concat(isOnStage));
      videoQualityData.push("pr:".concat(videoMetricsData['videoDownstreamPacketsReceived']));
      if (videoMetricsData['videoDownstreamPacketsReceived'] === 0) {
        this.processMeetingQuality(meetingQualityType, {
          videoScore: 1,
          fpsScore: 1,
          resolutionScore: 1,
          receivingMosScore: 1,
          senderMosScore: 1
        });
        videoQualityData.push('fs:1');
      } else {
        var videoPacketLossPercent = videoMetricsData['videoDownstreamPacketLossPercent'];
        var videoJitter = videoMetricsData['videoDownstreamJitterMs'];
        var videoRTT = this.metricReport['currentRoundTripTimeMs'];
        var videoMOS = this.computeMOS(videoPacketLossPercent, videoJitter, videoRTT);
        var senderMOS = 'NA';
        if (this.remoteAttendeeNetworkHealth.hasOwnProperty(attendeeId)) {
          senderMOS = this.remoteAttendeeNetworkHealth[attendeeId]['videoMOS'];
        }
        var videoQualityScore = this.getVideoQualityScore(attendeeId, videoMOS, senderMOS, videoMetricsData['videoDownstreamFramesDecodedPerSecond'], videoMetricsData['videoDownstreamFrameHeight']);
        videoQualityData.push("fh:".concat(videoMetricsData['videoDownstreamFrameHeight']));
        videoQualityData.push("efh:".concat((0, _networkHealthUtil.getExpectedResolutionHeight)(this.meetingSession)));
        videoQualityData.push("fps:".concat(videoMetricsData['videoDownstreamFramesDecodedPerSecond']));
        videoQualityData.push("smos:".concat(senderMOS));
        videoQualityData.push("rmos:".concat(videoMOS));
        videoQualityData.push("fs:".concat(videoQualityScore.videoScore));
        this.processMeetingQuality(meetingQualityType, videoQualityScore);
      }
      var dataSet = videoQualityData.join('::');
      if (isOnStage === 1) {
        this.meetingQuality.downVideo.onStage.dataSets.push(dataSet);
      } else {
        this.meetingQuality.downVideo.offStage.dataSets.push(dataSet);
      }
      return dataSet;
    }
  }, {
    key: "getUpstreamVideoQualityData",
    value: function getUpstreamVideoQualityData(attendeeId, videoMetricsData) {
      var videoQualityData = [];
      var isOnStage = this.isAttendeeOnStage(attendeeId) ? 1 : 0;
      this.upVideoCount += 1;
      this.meetingQuality.upVideo.available = true;
      videoQualityData.push("n:".concat((0, _networkHealthUtil.getNumMeetingParticipants)(this.meetingSession)));
      videoQualityData.push("os:".concat(isOnStage));
      if (isOnStage === 1) {
        this.meetingQuality.upVideo.onStage = true;
      }
      videoQualityData.push("ps:".concat(videoMetricsData['videoUpstreamPacketsSent']));
      if (videoMetricsData['videoUpstreamPacketsSent'] === 0) {
        this.processMeetingQuality(this.meetingQuality.upVideo, {
          videoScore: 1,
          fpsScore: 1,
          resolutionScore: 1,
          receivingMosScore: 1,
          senderMosScore: 1
        });
        videoQualityData.push('fs:1');
      } else {
        var videoPacketLossPercent = videoMetricsData['videoUpstreamPacketLossPercent'];
        var videoJitter = videoMetricsData['videoUpstreamJitterMs'];
        var videoRTT = this.metricReport['videoUpstreamRoundTripTimeMs'];
        var videoMOS = this.computeMOS(videoPacketLossPercent, videoJitter, videoRTT);
        var videoQualityScore = this.getVideoQualityScore(attendeeId, videoMOS, 'NA', videoMetricsData['videoUpstreamFramesInputPerSecond'], videoMetricsData['videoUpstreamFrameHeight']);
        videoQualityData.push("fh:".concat(videoMetricsData['videoUpstreamFrameHeight']));
        videoQualityData.push("efh:".concat((0, _networkHealthUtil.getExpectedResolutionHeight)(this.meetingSession)));
        videoQualityData.push("fps:".concat(videoMetricsData['videoUpstreamFramesInputPerSecond']));
        videoQualityData.push("rmos:".concat(videoMOS));
        videoQualityData.push("fs:".concat(videoQualityScore.videoScore));
        this.processMeetingQuality(this.meetingQuality.upVideo, videoQualityScore);
      }
      var dataSet = videoQualityData.join('::');
      this.meetingQuality.upVideo.dataSets.push(dataSet);
      return dataSet;
    }
  }, {
    key: "getOnstageAttendeeIds",
    value: function getOnstageAttendeeIds() {
      return Object.keys(this.onstageAttendees);
    }
  }, {
    key: "isAttendeeOnStage",
    value: function isAttendeeOnStage(attendeeId) {
      return this.onstageAttendees.hasOwnProperty(attendeeId);
    }
  }, {
    key: "isAttendeeSpeaking",
    value: function isAttendeeSpeaking(attendeeId) {
      return this.onstageAttendees.hasOwnProperty(attendeeId) && this.onstageAttendees[attendeeId].hasAudio === true;
    }
  }, {
    key: "computeMOS",
    value: function computeMOS(packetLoss, jitter, RTT) {
      if (!packetLoss) {
        packetLoss = 0;
      }
      if (!jitter) {
        jitter = 0;
      }
      if (!RTT) {
        RTT = 0;
      }
      var effectiveLatency = RTT + jitter * 2 + 10;
      var rFactor = 93.2 - effectiveLatency / 40;
      if (effectiveLatency >= 160) {
        rFactor = 93.2 - effectiveLatency / 120 - 10;
      }
      rFactor -= packetLoss * 2.5;
      if (rFactor < 0) {
        rFactor = 0;
      }
      var MOSScore = 1 + 0.035 * rFactor + 0.000007 * rFactor * (rFactor - 60) * (100 - rFactor);
      return Math.round(MOSScore * 100) / 100;
    }
  }, {
    key: "getMOSBasedQualityScore",
    value: function getMOSBasedQualityScore(MOS) {
      var MOSBasedScore = 1;
      if (MOS >= 4) {
        MOSBasedScore = 3;
      } else if (MOS >= 3) {
        MOSBasedScore = 2;
      }
      return MOSBasedScore;
    }
  }, {
    key: "getVideoQualityScore",
    value: function getVideoQualityScore(attendeeId, MOS, senderMOS, fps, resolutionFrameHeight) {
      var candidateScores = [];

      // Downstream video MOS
      var receivingMosScore = this.getMOSBasedQualityScore(MOS);
      candidateScores.push(receivingMosScore);
      var senderMosScore = 3;
      if (senderMOS !== undefined && senderMOS !== 'NA') {
        senderMosScore = this.getMOSBasedQualityScore(parseFloat(senderMOS));
        candidateScores.push(senderMosScore);
      }
      var isAttendeeOnStage = this.isAttendeeOnStage(attendeeId);
      var fpsScore = this.getVideoFPSBasedScore(fps, isAttendeeOnStage);
      candidateScores.push(fpsScore);
      var expectedResolutionFrameHeight = (0, _networkHealthUtil.getExpectedResolutionHeight)(this.meetingSession);
      var resolutionScore = 3;
      if (expectedResolutionFrameHeight) {
        resolutionScore = this.getVideoResolutionBasedScore(resolutionFrameHeight, expectedResolutionFrameHeight, isAttendeeOnStage);
        candidateScores.push(resolutionScore);
      }
      var videoScore = Math.min.apply(Math, candidateScores);
      return {
        videoScore: videoScore,
        resolutionScore: resolutionScore,
        receivingMosScore: receivingMosScore,
        senderMosScore: senderMosScore,
        fpsScore: fpsScore
      };
    }
  }, {
    key: "getVideoResolutionBasedScore",
    value: function getVideoResolutionBasedScore(resolutionFrameHeight, expectedResolutionFrameHeight, isAttendeeOnStage) {
      if (!isAttendeeOnStage) {
        return 3;
      }
      var resolutionBasedScore = 1;
      if (resolutionFrameHeight === expectedResolutionFrameHeight || resolutionFrameHeight === 480) {
        resolutionBasedScore = 3;
      } else if (resolutionFrameHeight < expectedResolutionFrameHeight && resolutionFrameHeight >= 360) {
        resolutionBasedScore = 2;
      }
      return resolutionBasedScore;
    }
  }, {
    key: "getVideoFPSBasedScore",
    value: function getVideoFPSBasedScore(fps, isAttendeeOnStage) {
      if (isAttendeeOnStage) {
        if (fps >= 15) {
          return 3;
        } else if (fps >= 10) {
          return 2;
        } else {
          return 1;
        }
      } else {
        if (fps >= 15) {
          return 3;
        } else if (fps >= 5) {
          return 2;
        } else {
          return 1;
        }
      }
    }
  }, {
    key: "processMeetingQuality",
    value: function processMeetingQuality(meetingData, scores) {
      this.updateMeetingQualityScores(meetingData.videoScore, scores.videoScore);
      this.updateMeetingQualityScores(meetingData.fpsScore, scores.fpsScore);
      this.updateMeetingQualityScores(meetingData.resolutionScore, scores.resolutionScore);
      this.updateMeetingQualityScores(meetingData.receivingMosScore, scores.receivingMosScore);
      this.updateMeetingQualityScores(meetingData.senderMosScore, scores.senderMosScore);
    }
  }, {
    key: "updateMeetingQualityScores",
    value: function updateMeetingQualityScores(valueType, valueToCheck) {
      if (valueType.min === 0 || valueType.min > valueToCheck) {
        valueType.min = valueToCheck;
      }
      if (valueType.max === 0 || valueType.max < valueToCheck) {
        valueType.max = valueToCheck;
      }
      valueType.avg += valueToCheck;
    }
  }, {
    key: "calculateVideoScoreAvgs",
    value: function calculateVideoScoreAvgs(meetingData, totalCount) {
      if (totalCount > 1) {
        meetingData.videoScore.avg = Math.round(meetingData.videoScore.avg / totalCount * 100) / 100;
        meetingData.fpsScore.avg = Math.round(meetingData.fpsScore.avg / totalCount * 100) / 100;
        meetingData.resolutionScore.avg = Math.round(meetingData.resolutionScore.avg / totalCount * 100) / 100;
        meetingData.receivingMosScore.avg = Math.round(meetingData.receivingMosScore.avg / totalCount * 100) / 100;
        meetingData.senderMosScore.avg = Math.round(meetingData.senderMosScore.avg / totalCount * 100) / 100;
      }
    }
  }]);
  return ChimeMetricsProcessor;
}();